// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#captcha-box-register-bigo-captcha-element{background-color:#f5f7fa!important}", ""]);
// Exports
module.exports = exports;
